/* global jQuery, document, wpk_script_object */ //variable Not defined
/* exported */ //Variable Defined but never used
jQuery(document).ready(function($){
	
	//********************************
    //VARIABLES
	//********************************
	
	//If you declare variables (empty or not) outside the functions, like below, 
	//they will be available in/for all functions later.
	//Timeout
	var timeout;
	
	//********************************
    //TRIGGERS
	//********************************
	
	
	//********************************
    //FUNCTIONS
	//********************************

	//Load (page completed)
	//************************************
	$(window).on('load', function(){
		$('body').removeClass('wpk-resize');
	});
	
	//Load (page completed) or Resize functions (throttled)
	//************************************
	$(window).on('load resize', function(){
		//Remove animation class on nav menu when resize, to stop nav from anim on resize break points
		clearTimeout(timeout);
		$('body').addClass('wpk-resize');
		timeout = setTimeout(function(){
			$('body').removeClass('wpk-resize');
		}, 500);
	});

    
}); //End jQuery